var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.453,
    height: 34.455,
    viewBox: "0 0 34.453 34.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "0ihd7cgwxa",
    x: 0,
    y: 0,
    width: 34.453,
    height: 34.455,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#0ihd7cgwxa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "dashboard",
    d: "M18.93 8.461 10.993.524a1.791 1.791 0 0 0-2.533 0L.528 8.456l-.008.008a1.79 1.79 0 0 0 1.192 3.051h.371v5.84a2.1 2.1 0 0 0 2.1 2.1h3.1a.57.57 0 0 0 .57-.57v-4.579a.957.957 0 0 1 .956-.956h1.831a.957.957 0 0 1 .956.956v4.579a.57.57 0 0 0 .57.57h3.1a2.1 2.1 0 0 0 2.1-2.1v-5.84h.293a1.791 1.791 0 0 0 1.271-3.054zm0 0",
    transform: "translate(7.5 6.5)",
    style: {
      fill: "#d9d9d9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.295e6e5685b37575faaad8c67a413c06.svg";
export { ForwardRef as ReactComponent };